// extracted by mini-css-extract-plugin
export default {"topic":"summary_topic__5Asta","trending_negative":"summary_trending_negative__LZ8Ih","trending_positive":"summary_trending_positive__PrbXA"};